export default __webpack_public_path__ + "static/carousel-biogenetics-f6c4742929f5e6d26aa0b8955ff21002.png";